import { useTranslation } from "react-i18next";
import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import Layout from '../../Components/Layout/Layout';
import Connections from '../../Components/Personal/Connections';
import './Personal.css';

function ConnectionsPage() {
  const {
    t
  } = useTranslation();
  return <Layout>
            <Helmet>
                <title>{t("My Connections - HeresMyInfo.com")}</title>
            </Helmet>
            <Connections />
        </Layout>;
}

const mapStateToProps = state => ({
  parse: state.auth.parse
});

export default connect(mapStateToProps)(ConnectionsPage);